@if (isShowByLevel() && isShowByJoinDate()) {
    <div class="flex gap-2 px-4 py-4 rounded justify-between items-center mb-2 bg-primary relative overflow-hidden flex-col md:flex-row">
      <img src="https://storage.googleapis.com/komerce/rajaongkir/light-bg-banner.png" alt="bg-left" class="absolute top-[-140px] left-[-60px] h-[500px] object-cover mix-blend-lighten pointer-events-none rotate-[60deg]">
        <div class="flex flex-col gap-1 text-white relative z-10">
            <span class="title font-bold text-lg">Tingkatkan Bisnis Anda ke Level Berikutnya!</span>
            <div class="flex gap-2">
                <span>Nikmati lebih banyak fitur untuk bisnismu dengan upgrade ke <b>Pro/Enterprise</b>.</span>
            </div>
        </div>
        <button class="bg-white rounded-xl font-medium px-4 py-2 text-black ring-[6px] ring-white/30 relative z-10" (click)="handleUpgrade()">Upgrade Sekarang</button>
        <img src="https://storage.googleapis.com/komerce/rajaongkir/light-bg-banner.png" alt="bg-left" class="absolute top-[-100px] right-[-100px] h-[500px] object-cover mix-blend-lighten pointer-events-none">
    </div>
}
